export const QUESTIONNAIRE_MAX_TIME = 3 * 60 * 60 * 1000;